import { produce } from 'immer'
import { expensesAllReportsRouteProps } from 'src/navigation/routeProps'
import {
  GET_SUBMITTER_USERS_FAILURE,
  GET_SUBMITTER_USERS_INIT,
  GET_SUBMITTER_USERS_SUCCESS,
  GetSubmitterUsersActions,
} from 'src/redux/actions/data/expenses.actions'
import { createBackgroundReducer } from 'src/redux/genericReducers'
import { ErrorDetailMap, parseBackendErrors } from 'src/utils/error.utils'

export interface SubmitterUsersState {
  ids: string[]
  loading: boolean
  complete: boolean
  getSubmitterUserTopLevelError?: string
  getSubmitterUsersErrorDetailMap?: ErrorDetailMap<string>
}

export const initialState: SubmitterUsersState = {
  ids: [],
  loading: false,
  complete: false,
}

export type Actions = GetSubmitterUsersActions

const CoreSubmitterUsersReducer = (
  state = initialState,
  action: Actions,
): SubmitterUsersState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case GET_SUBMITTER_USERS_INIT: {
        draft.loading = true
        return draft
      }

      case GET_SUBMITTER_USERS_SUCCESS: {
        draft.loading = false
        draft.ids = [...draft.ids, ...action.payload.map((user) => user.id)]
        draft.complete = true
        return draft
      }

      case GET_SUBMITTER_USERS_FAILURE: {
        draft.loading = false
        draft.complete = true
        const errors = parseBackendErrors(action.payload)
        draft.getSubmitterUserTopLevelError = errors.topLevelError
        draft.getSubmitterUsersErrorDetailMap = errors.errorDetailMap
        return draft
      }
    }
  })
}

const SubmitterUsersReducer = createBackgroundReducer(
  expensesAllReportsRouteProps,
  initialState,
  CoreSubmitterUsersReducer,
)

export default SubmitterUsersReducer
